
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import TestQuestionVersion from "@/models/unit/unitable/test/question_version";
import TestVersion from "@/models/unit/unitable/test/version";
import ImageView from "@/components/ImageView.vue";
import SubscriptionUnit from "@/models/subscriptions/unit";

@Component({
  components: {
    ImageView
  }
})
export default class SubscriptionUnitResult extends Vue {
  @Prop({ required: true }) public test_version!: TestVersion;

  public questions_count: number = 0;
  public correct_score: number = 0;
  public correct_count: number = 0;
  public correct_percent: number = 0;

  public setResults() {
    this.questions_count = this.test_version.question_versions.length;
    this.correct_score = this.test_version.score;
    this.correct_count = this.test_version.question_versions.filter(
      qv => qv.is_correct
    ).length;
    this.correct_percent = +(
      (this.correct_count / (this.questions_count ?? 1)) *
      100
    ).toFixed(2);
  }

  protected created() {
    this.setResults();
  }

  @Watch("test_version")
  protected changeTestVersion() {
    this.setResults();
  }
}
